// One-shot Summer Focus Fest extension notice. The notice window closes at
// 2026-08-20 00:00 GMT+8 (server clock — pass the useTimestamp value, not
// the device clock); after that this module is dead code for any future
// event this app serves.
const DEADLINE = Date.parse('2026-08-20T00:00:00+08:00')

// Seen is per device, not per account: showing the dialog once marks it.
const STORAGE_KEY = 'summer_focus_extend_dialog_seen'

export function shouldShowExtensionNotice(now: number): boolean {
  if (now >= DEADLINE) return false
  try {
    return localStorage.getItem(STORAGE_KEY) === null
  } catch {
    // Storage unavailable — better to repeat the notice than never show it.
    return true
  }
}

export function markExtensionNoticeSeen(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1')
  } catch {
    // Storage unavailable — the App-side once-per-mount guard still holds.
  }
}
